import script from "./Datepicker2.vue?vue&type=script&setup=true&lang=js"
export * from "./Datepicker2.vue?vue&type=script&setup=true&lang=js"

import "./Datepicker2.vue?vue&type=style&index=0&id=7c6fb2aa&lang=css"

const __exports__ = script;

export default __exports__